import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  LayoutDashboard, MessageSquare, HelpCircle, BarChart3, 
  LogOut, Menu, X, CalendarDays, Calendar, Settings, Search, MapPin, Bot, Globe, Image, BookOpen, Star, ArrowLeft
} from 'lucide-react';

const Logo = ({ className = "" }) => (
  <div className={`flex items-center ${className}`}>
    <span className="text-white font-bold text-xl tracking-tighter">Jasne</span>
    <span className="text-[#00BFFF] font-bold text-xl tracking-tighter">Svetla</span>
  </div>
);

export { Logo };

// Sidebar Component
export const Sidebar = ({ activeTab, setActiveTab, isMobileOpen, setMobileOpen }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const navItems = [
    { id: 'dashboard', label: 'Prehľad', icon: LayoutDashboard },
    { id: 'calendar', label: 'Kalendár', icon: CalendarDays },
    { id: 'bookings', label: 'Rezervácie', icon: Calendar },
    { id: 'messages', label: 'Správy', icon: MessageSquare },
    { id: 'blog', label: 'Blog', icon: BookOpen },
    { id: 'gallery', label: 'Galéria', icon: Image },
    { id: 'reviews', label: 'Hodnotenia', icon: Star },
    { id: 'chats', label: 'AI Chaty', icon: Bot },
    { id: 'faq', label: 'FAQ', icon: HelpCircle },
    { id: 'stats', label: 'Štatistiky', icon: BarChart3 },
    { id: 'aiseo', label: 'AI SEO', icon: Globe },
    { id: 'seo', label: 'SEO', icon: Search },
    { id: 'geo', label: 'GEO', icon: MapPin },
    { id: 'ai', label: 'AI', icon: Bot },
    { id: 'settings', label: 'Nastavenia', icon: Settings },
  ];

  const sidebarContent = (
    <>
      <div className="p-6 border-b border-white/10">
        <Logo />
        <p className="text-xs text-zinc-500 mt-2">Admin Panel</p>
      </div>

      <nav className="flex-1 p-4 space-y-2">
        {navItems.map((item) => (
          <button
            key={item.id}
            data-testid={`nav-${item.id}`}
            onClick={() => {
              setActiveTab(item.id);
              setMobileOpen(false);
            }}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${
              activeTab === item.id
                ? 'bg-[#00BFFF]/10 text-[#00BFFF] border border-[#00BFFF]/20'
                : 'text-zinc-400 hover:bg-white/5 hover:text-white'
            }`}
          >
            <item.icon className="w-5 h-5" />
            <span className="font-medium">{item.label}</span>
          </button>
        ))}
      </nav>

      <div className="p-4 border-t border-white/10">
        <button
          data-testid="logout-btn"
          onClick={handleLogout}
          className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-zinc-400 hover:bg-red-500/10 hover:text-red-400 transition-all"
        >
          <LogOut className="w-5 h-5" />
          <span className="font-medium">Odhlásiť sa</span>
        </button>
        <Link
          to="/"
          className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-zinc-400 hover:bg-white/5 hover:text-white transition-all mt-2"
        >
          <ArrowLeft className="w-5 h-5" />
          <span className="font-medium">Na stránku</span>
        </Link>
      </div>
    </>
  );

  return (
    <>
      {/* Desktop Sidebar */}
      <aside className="hidden md:flex w-64 flex-col bg-white/[0.02] border-r border-white/10 h-screen fixed left-0 top-0">
        {sidebarContent}
      </aside>

      {/* Mobile Sidebar */}
      {isMobileOpen && (
        <div className="md:hidden fixed inset-0 z-50">
          <div 
            className="absolute inset-0 bg-black/50"
            onClick={() => setMobileOpen(false)}
          />
          <aside className="absolute left-0 top-0 bottom-0 w-64 flex flex-col bg-[#05050A] border-r border-white/10">
            {sidebarContent}
          </aside>
        </div>
      )}
    </>
  );
};
